import type { ReactNode } from 'react';

import type { Session } from '@/entities/session';
import type { SoapContent, UpdateSessionNoteContentFn } from '@/entities/session-note';

import { SoapSessionNoteContent } from './soap-session-note/soap-session-note-content';

const BLANK_SOAP_CONTENT: SoapContent = {
    subjective: '',
    objective: '',
    assessment: '',
    plan: '',
};

interface Props {
    session: Session;
    header: ReactNode;
    disclaimer: ReactNode;
    updateContent: UpdateSessionNoteContentFn;
}

export function SoapSessionNote({ session, header, disclaimer, updateContent }: Props) {
    const note = session.currentNote?.type === 'SOAP' ? session.currentNote : null;
    const soapContent = note?.content ?? BLANK_SOAP_CONTENT;
    const updateSection = (key: keyof SoapContent, value: string) => {
        updateContent('SOAP', { ...soapContent, [key]: value });
    };

    return (
        <div className="max-w-[38.875rem] space-y-8">
            {header}
            <SoapSessionNoteContent
                content={soapContent}
                updateSection={updateSection}
                disclaimer={disclaimer}
            />
        </div>
    );
}
